"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdAction = void 0;
var tslib_1 = require("tslib");
var interfaces_1 = require("@dp-instant/interfaces");
var core_1 = require("@dp-instant/core");
var inversify_1 = require("inversify");
var _1 = require("./");
var AdAction = (function (_super) {
    tslib_1.__extends(AdAction, _super);
    function AdAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AdAction.prototype.execute = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var placement, reward, preloadNext;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        placement = undefined;
                        reward = false;
                        preloadNext = true;
                        if (typeof data === "boolean") {
                            reward = data;
                        }
                        else if (typeof data !== "undefined") {
                            placement = data.placement;
                            reward = data.reward;
                            preloadNext = data.preloadNext;
                        }
                        return [4, this.showAd(placement, reward, preloadNext)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    AdAction.prototype.showAd = function (placement, isReward, preloadNext) {
        if (isReward === void 0) { isReward = false; }
        if (preloadNext === void 0) { preloadNext = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var status;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        status = interfaces_1.AdResponse.UNKNOWN;
                        if (!isReward) return [3, 2];
                        return [4, this.ads.showRewardAd(placement || _1.AdManagerBase.config.ids.REWARD, preloadNext)];
                    case 1:
                        status = _a.sent();
                        return [3, 4];
                    case 2: return [4, this.ads.showAd(placement || _1.AdManagerBase.config.ids.INTER, false, preloadNext)];
                    case 3:
                        status = _a.sent();
                        _a.label = 4;
                    case 4: return [2, status];
                }
            });
        });
    };
    AdAction.prototype.showRewardAd = function (placement, preloadNext) {
        if (placement === void 0) { placement = _1.AdManagerBase.config.ids.REWARD; }
        if (preloadNext === void 0) { preloadNext = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2, this.showAd(placement, true, preloadNext)];
            });
        });
    };
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesAds.manager),
        tslib_1.__metadata("design:type", Object)
    ], AdAction.prototype, "ads", void 0);
    AdAction = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], AdAction);
    return AdAction;
}(core_1.Action));
exports.AdAction = AdAction;
//# sourceMappingURL=AdAction.js.map